import { DomApplier } from '../cssFeatures.types'
import { getVariantKey, getVariantSelectors } from '../../utils/variantsUtils'
import { SelectorToCssString } from '../../shared.types'

export const presetsDomApplier: DomApplier<'presets'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ presets },
	cssContext
): SelectorToCssString | null => {
	const presetInBp = presets?.[breakpointId]
	if (presetInBp) {
		// todo default default should be without the ref component selector.
		return presetInBp.reduce((acc: SelectorToCssString, presetData) => {
			const { presetCss, variants } = presetData
			const selector = getVariantSelectors(getVariantKey(variants), variants, compId, cssContext).join(',')
			const presetCssWithoutRepeaterDelimiter = (presetCss as string).replace(/__"]/g, '"]')
			const presetCssWithSelector = `${selector}{${presetCssWithoutRepeaterDelimiter as string}}`
			if (acc[selector]) {
				acc[selector] = `${acc[selector]}${presetCssWithSelector}`
			} else {
				acc[selector] = presetCssWithSelector
			}
			return acc
		}, {})
	}

	return null
}
